import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Scale } from 'lucide-react';

const Login = () => {
  const { login, signup } = useAuth();
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    nome: '',
    escritorio_nome: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (isSignup) {
      const result = await signup(formData.email, formData.password, formData.nome, formData.escritorio_nome);
      if (result.success) {
        alert('Conta criada com sucesso! Faça login para continuar.');
        setIsSignup(false);
      } else {
        setError(result.error);
      }
    } else {
      const result = await login(formData.email, formData.password);
      if (!result.success) {
        setError(result.error);
      }
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 px-4" data-testid="login-page">
      <Card className="w-full max-w-md shadow-lg" data-testid="login-card">
        <CardHeader className="space-y-3 text-center">
          <div className="mx-auto w-16 h-16 bg-slate-900 rounded-xl flex items-center justify-center">
            <Scale className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-2xl font-semibold text-slate-900">
            {isSignup ? 'Criar Conta' : 'Advocacia Fulini'}
          </CardTitle>
          <CardDescription className="text-slate-600">
            {isSignup ? 'Cadastre seu escritório' : 'Acesse sua conta para continuar'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {isSignup && (
              <>
                <div className="space-y-2">
                  <Label htmlFor="nome">Nome Completo</Label>
                  <Input
                    id="nome"
                    data-testid="signup-nome-input"
                    type="text"
                    required
                    value={formData.nome}
                    onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                    placeholder="Seu nome completo"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="escritorio">Nome do Escritório</Label>
                  <Input
                    id="escritorio"
                    data-testid="signup-escritorio-input"
                    type="text"
                    required
                    value={formData.escritorio_nome}
                    onChange={(e) => setFormData({ ...formData, escritorio_nome: e.target.value })}
                    placeholder="Nome do seu escritório"
                  />
                </div>
              </>
            )}
            <div className="space-y-2">
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="seu@email.com"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm" data-testid="error-message">
                {error}
              </div>
            )}

            <Button
              type="submit"
              className="w-full bg-slate-900 hover:bg-slate-800"
              disabled={loading}
              data-testid="submit-button"
            >
              {loading ? 'Processando...' : (isSignup ? 'Criar Conta' : 'Entrar')}
            </Button>

            <div className="text-center text-sm">
              <button
                type="button"
                onClick={() => setIsSignup(!isSignup)}
                className="text-slate-600 hover:text-slate-900 underline"
                data-testid="toggle-mode-button"
              >
                {isSignup ? 'Já tem uma conta? Faça login' : 'Não tem conta? Cadastre-se'}
              </button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;